import { useEffect, useState } from 'react';

// Vrai quand le bouton d'appel à l'action du haut de page est passé au-dessus
// de l'écran (on a fait défiler) : le bouton fixe peut alors apparaître.
export function useHeroCtaHidden(id: string) {
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const el = document.getElementById(id);
    if (!el) return;
    const check = () => setHidden(el.getBoundingClientRect().bottom < 0);
    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, [id]);
  return hidden;
}
